import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import {
    Image as VanImage,
    RadioGroup,
    Calendar,
    Radio,
    ActionSheet,
    Button,
    Toast,
    List,
    NavBar,
    Field,
    Form,
    Cell,
    CellGroup,
    Popup,
    DatetimePicker,
    Picker,
    Dialog,
    Divider,
    CheckboxGroup,
    Checkbox,
    Skeleton,
    Collapse,
    CollapseItem,
    NoticeBar,
    Uploader,
    Sidebar,
    SidebarItem,
    Icon,
    Empty,
    Tab,
    Tabs,
    Col, Row,
} from 'vant';
import {userCheckNotice} from "@/api/user";

Vue.use(Sidebar).use(SidebarItem);
Vue.use(Empty);
Vue.use(Calendar);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Button);
Vue.use(ActionSheet);
Vue.use(Toast);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(List).use(Icon);
Vue.use(NavBar).use(Uploader);
Vue.use(Field).use(NoticeBar);
Vue.use(Form);
Vue.use(Cell).use(CellGroup).use(Popup).use(DatetimePicker).use(Picker).use(Dialog).use(Divider).use(Checkbox).use(
    CheckboxGroup).use(Skeleton).use(Collapse).use(CollapseItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(VanImage);

Toast.allowMultiple();

Vue.mixin({
    methods: {
        preCheck() {
            return new Promise(function (resolve) {
                userCheckNotice().then((rep) => {
                    if (rep.data && rep.data.length > 0) {
                        const notice = rep.data[0];
                        Dialog.alert({
                            title: notice.title,
                            message: notice.message
                        }).then(() => {
                            resolve(true);
                        });
                    } else {
                        resolve(true);
                    }
                }).catch((err) => {
                    console.info(err)
                    resolve(false)
                })
            })
        }
    }
})


Vue.config.productionTip = false
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
